<script context="module">
  export const NOTIFICATION_TYPE = {
    NULL: '',
    VIP_REDEEMED: 'VIP_REDEEMED',
    MEMBERSHIP_CHANGED: 'MEMBERSHIP_CHANGED',
    RENEWAL_PLAN_CHANGED: 'RENEWAL_PLAN',
  }
</script>

<script>
  import { CheckmarkIcon } from './icons'
  const messages = {
    [NOTIFICATION_TYPE.VIP_REDEEMED]: 'VIP membership redeemed successfully!',
    [NOTIFICATION_TYPE.MEMBERSHIP_CHANGED]: 'Membership changed successfully!',
    [NOTIFICATION_TYPE.RENEWAL_PLAN_CHANGED]: 'Renewal plan changed successfully!',
  }

  export let notification = NOTIFICATION_TYPE.NULL

  let message = ''

  $: {
    message = messages[notification] || ''
  }
</script>

<style>
  .wrapper {
    width: 100%;
    background: #E9FBF6;
    font-size: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 24px 0;
    line-height: 1.5;
  }
  .checkmark {
    width: 20px;
    height: 20px;
    padding: 0 24px;
    flex: 0 0 20px;
  }
  .icon-close {
    font-family: monospace;
    padding: 0 24px;
    font-size: 24px;
  }
</style>

<div class="wrapper" data-cy="notification">
  <div class="checkmark"><CheckmarkIcon /></div>
  <div class="content">{message}</div>
  <span class="icon-close" on:click>⨯</span>
</div>